export default "__VITE_ASSET__hpZwe5P___"